import React, { Fragment } from 'react';
import { bool, number, string } from 'prop-types';
import { Row, Col } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Css from './NewsItem.scss';

const propTypes = {
  date: string.isRequired,
  index: number.isRequired,
  isMobile: bool.isRequired,
  link: string.isRequired,
  source: string.isRequired,
  title: string.isRequired
};

const NewsItem = ({ date, index, isMobile, link, source, title }) => {
  const itemStyles = isMobile ? { marginBottom: '1rem' } : {};

  return (
    <Fragment>
      <Col
        key={index}
        xs={12}
        sm={6}
        md={4}
        lg={4}
        className={'d-inline-flex flex-column float-none'}
        style={itemStyles}
      >
        <div className={`${Css['list-box']} lakes-bold`}>
          <div className={Css['title']}>{title}</div>
          <div className={Css['date']}>
            <strong>{date}</strong>
          </div>
          <div className={Css['source']}>{source}</div>
        </div>
        <a
          href={link}
          target={'_blank'}
          rel="noopener"
          style={{ textDecoration: 'none' }}
        >
          <div className={Css['visit']}>
            <strong>Visit This Story</strong>
          </div>
          <Row>
            <Col xs={10}>
              <div className={Css['arrow-shaft']} />
            </Col>
            <Col xs={2} className={`${Css['arrow-icon']} pl-0`}>
              <FontAwesomeIcon
                color={'red'}
                icon={['far', 'chevron-right']}
                className={'float-right mt-1'}
              />
            </Col>
          </Row>
        </a>
      </Col>
      {(index === 8 || index === 16) && <br />}
    </Fragment>
  );
};

NewsItem.propTypes = propTypes;

export default NewsItem;



// WEBPACK FOOTER //
// ./src/components/News/NewsItem/NewsItem.jsx